import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ArchivedDashboardT, DashboardT } from 'business/definitions';
import { RQAPICallWithData } from 'store/APIClient';

export const ACTIVE_DASHBOARDS_QUERY_KEY = 'dashboards';
export const OTHER_DASHBOARDS_QUERY_KEY = 'other_dashboards';
export const ARCHIVED_DASHBOARDS_QUERY_KEY = 'archived_dashboards';

/**
 * Fetches active dashboards.
 */
export const useFetchActiveDashboards = () =>
    useQuery({
        queryKey: [ACTIVE_DASHBOARDS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT[]>({
                endpoint: 'explore/dashboards',
                method: 'GET',
            });
            return response.content.data;
        },
    });

/**
 * Fetches archived dashboards.
 */
export const useFetchArchivedDashboards = () =>
    useQuery({
        queryKey: [ARCHIVED_DASHBOARDS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<ArchivedDashboardT[]>({
                endpoint: 'explore/archived_dashboards',
                method: 'GET',
            });
            return response.content.data;
        },
    });

/**
 * Fetches other dashboards.
 * This is a list of dashboards that are not owned by the user.
 */
export const useFetchOtherDashboards = (): UseQueryResult<DashboardT[]> =>
    useQuery({
        queryKey: [OTHER_DASHBOARDS_QUERY_KEY],
        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT[]>({
                endpoint: 'explore/other_dashboards',
                method: 'GET',
            });
            return response.content.data.map((dashboard) => ({
                ...dashboard,
                isSupportAccess: true,
            }));
        },
        initialData: [],
    });
